import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { VoucherInitStepDeclaration } from "./Steps/VoucherInitStep";

export const VoucherStartupFlow = new FlowDefinition("VoucherFlow");

VoucherStartupFlow.addStep(VoucherInitStepDeclaration);

VoucherStartupFlow.setStartStep("VoucherInit_Step");

export const voucherStartupFlowDefinition = new StepDefinition({
    stepName: "VoucherFlow",
    stepFlow: VoucherStartupFlow,
    contextIsolation: false
})